<template>
  <div id="header" class="mt-2">
    <b-navbar-nav class="ml-auto float-right user-name mr-2" v-if="isLoggedIn">
      <b-nav-item to="/profile">
        <span class="fas fa-user"></span>
        Hello
        {{ user.first_name }}
      </b-nav-item>
    </b-navbar-nav>
    <nav class="navbar navbar-light p-2 mb-2">
      <a class="navbar-brand" href="#">
        <span class="title">
          <img class="logo" src="/logo.png" /> DECSA
          <!-- EMURRAGE AND COLLECTION S.A -->
        </span>
      </a>
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["account", "user", "isLoggedIn", "appVersion"]),
  },
};
</script>
